import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useEffect, useState } from 'react';
import CircularProgressWithLabel from 'pages/Utilities/EpicAdministration/components/CircularProgressWithLabel';//./CircularProgressWithLabel
import axiosInstance from '../../../../services/axios/axios'
import { WrapImsPacket } from 'store/utility';
import Button from '@mui/material/Button';
import { useHistory } from 'react-router-dom';
import { PAGE_ICONS, PAGE_ROUTES } from '../../_const';
import HomeIcon from '@mui/icons-material/Home';

const ReassignSubmissionSummary = ({
	icon,
	title,
	description,
	navigation,
	role,
	userData,
	selectedManager,
	currentManager,
	...props
}) => {
	const [progress, setProgress] = useState(10);
	const [isLoading, setIsLoading] = useState(true);
	const [isSubmitting, setIsSubmitting] = useState(true);
	const [submittedSuccessfully, setSubmittedSuccessfully] = useState(false);
	const history = useHistory();

	useEffect(() => {
		const timer = setInterval(() => {
			setProgress(prevProgress =>
				Math.min(prevProgress + Math.floor(Math.random() * 25), 100)
			);
		}, 800);
		return () => {
			clearInterval(timer);
		};
	}, []);

	useEffect(() => {
		if (isLoading && progress >= 100) {
			setIsLoading(false);
		}
	}, [progress, isLoading, setIsLoading]);

	useEffect(() => {
		/**
	 * actions to take upon form submission
	 */
		setIsSubmitting(true)
		const payload = {
			newOwner: {
				esoFiId: selectedManager.FI_ID.Value,
			},
			loggedInUser: currentManager,
			targets: [
				{
					esoFiId: userData.esoFiId,
					type: 'nonEmployee',
				},
			],
		};
		axiosInstance
			.post(
				'/api/UserAccessReview/Reassignment',
				WrapImsPacket(payload)
			)
			.then(response => {
				switch (response.status) {
					case 200:
						if (response.data.responseCode) {
							const responseCode = response.data.responseCode;
							switch (responseCode) {
								case 200:
									setSubmittedSuccessfully(true);
									break;
								default:
									setIsSubmitting(false);
									setSubmittedSuccessfully(false);
									break;
							}
						}
						break;

					default:
						setIsSubmitting(false);
						setSubmittedSuccessfully(false);
						break;
				}
			})
			.catch(errors => {
				setIsSubmitting(false);
				setSubmittedSuccessfully(false);
			});
	}, []);

	return (
		<>
			{isSubmitting && isLoading ? (
				<Card variant='outlined'>
					<CardContent>
						<Stack direction='column' alignItems='center' gap={1}>
							<CircularProgressWithLabel value={progress} />
							<Typography color='text.secondary'>
								Submission in progress. Please do not leave this
								page.
							</Typography>
						</Stack>
					</CardContent>
				</Card>
			) : (
				<>
				{submittedSuccessfully ? (
					<Card variant='outlined'>
						<CardContent>
							<Stack direction='row' alignItems='center' gap={1}>
								<CheckCircleOutlineIcon
									sx={{
										color: theme =>
											theme.palette.success.light,
									}}
								/>
								<Typography variant='h5' component='div'>
									Successfully Submitted
								</Typography>
							</Stack>
							<Typography variant='body2' sx={{ mt: 1.5 }}>
								<b>Old Manager:</b> {userData.supervisorName} <span>&#8594;</span> <b>New Manager:</b> {selectedManager.Name.Value} <br />
							</Typography>
							<Stack direction='column' alignItems='center' gap={2} sx={{ mt: 1.5 }}>
								<Button
									variant='contained'
									startIcon={<PAGE_ICONS.HOME />}
									onClick={() => history.push(PAGE_ROUTES.HOME)}
								>
									Back to User Access Review Home Page
								</Button>
								<Button
									variant='contained'
									startIcon={<HomeIcon />}
									onClick={() => history.push('/index.html')}
								>
									Back to IMS Home Page
								</Button>
							</Stack>
						</CardContent>
					</Card>
					
				) : (
					<Card variant='outlined'>
						<CardContent>
							<Stack direction='row' alignItems='center' gap={1}>
								<Typography variant='h5' component='div'>
								Submission was unsuccessful. Please return home and try again.
								</Typography>
							</Stack>
							<Stack
								direction='row'
								alignItems='center'
								gap={2}
								sx={{ mt: 1.5 }}
							>
							</Stack>
						</CardContent>
					</Card>
				)}
				</>
			)}
		</>
	);
};

export default ReassignSubmissionSummary;
